import { Modal } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { Refresh01 } from 'blaze-ui/icons/20/Refresh01'
import Styles from '../RefineMediaModal.module.scss'

interface RefineSettingsProps {
  topic: string
  setTopic: (topic: string) => void
  sourceImageUrl: string
  error: string | null
  generationCost: number | undefined
  onClose: () => void
  onRegenerate: () => void
  onReplaceImage: () => void
}

export function RefineSettings({
  topic,
  setTopic,
  sourceImageUrl,
  error,
  generationCost,
  onClose,
  onRegenerate,
  onReplaceImage,
}: RefineSettingsProps) {
  return (
    <>
      <Modal.Header title="Revise topic and source image" onClose={onClose} />
      <Modal.Content>
        <div className={Styles.reviewContent}>
          <div className={Styles.formSection}>
            <div className={Styles.topicLabel}>
              <Text variant="primary" color="dark-90">
                Topic
              </Text>
            </div>
            <textarea
              id="refine-topic"
              className={Styles.textarea}
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              placeholder="Enter the topic for refinement..."
            />
          </div>
          <div className={Styles.formSection}>
            <div className={Styles.sourceHeader}>
              <Text variant="primary" color="dark-90">
                Source Image
              </Text>
              <Button variant="tertiary" size="sm" frontIcon={Refresh01} onPress={onReplaceImage}>
                Replace
              </Button>
            </div>
            <div className={Styles.thumbnailContainer}>
              <img src={sourceImageUrl} alt="Source" className={Styles.thumbnail} />
            </div>
          </div>
        </div>
        {error && <div className={Styles.error}>{error}</div>}
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="lg" onPress={onClose}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button size="lg" onPress={onRegenerate} isDisabled={!topic.trim()}>
            Regenerate <Credits /> {generationCost}
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
